import type { Pinia } from "pinia";

type TranslateFunction = (key: string, ...args: unknown[]) => string;

interface AppRuntimeState {
  pinia?: Pinia;
  translate?: TranslateFunction;
}

const state: AppRuntimeState = {};

export function setPiniaInstance(pinia?: Pinia) {
  state.pinia = pinia;
}

export function getRegisteredPinia() {
  return state.pinia;
}

export function setTranslator(translate?: TranslateFunction) {
  state.translate = translate;
}

export function translate(key: string, ...args: unknown[]) {
  if (!state.translate) {
    throw new Error(
      "Translation function is not initialized. Register it from the app bootstrap before using translated shared stores.",
    );
  }

  return state.translate(key, ...args);
}

export function clearAppRuntime() {
  state.pinia = undefined;
  state.translate = undefined;
}
